import { cn } from '../../lib/cn';

type Props = {
  greeting?: string;
  userName?: string;
  organization?: string;
  workspace?: string;
  marketplace?: string;
  brand?: string;
  role?: string;
  healthScore?: number;
  className?: string;
};

export function WelcomeBanner({
  greeting,
  userName = 'there',
  organization = 'Acme Commerce',
  workspace = 'Amazon India',
  marketplace = 'Amazon.in',
  brand = 'Nakabh',
  role = 'Brand Owner',
  healthScore = 82,
  className,
}: Props) {
  const chips = [
    { label: 'Org', value: organization },
    { label: 'Workspace', value: workspace },
    { label: 'Marketplace', value: marketplace },
    { label: 'Brand', value: brand },
    { label: 'Role', value: role },
  ];

  return (
    <div className={cn('rounded-xl border border-brand-200 bg-gradient-to-r from-brand-50 to-white p-5 dark:border-brand-900 dark:from-brand-950 dark:to-slate-900', className)}>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">Executive Home</p>
          <h2 className="mt-1 text-xl font-semibold text-slate-900 dark:text-slate-100">
            {greeting ?? 'Good morning'}, {userName}
          </h2>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            Business health score: <span className="font-semibold text-brand-700 dark:text-brand-300">{healthScore}/100</span>
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          {chips.map((c) => (
            <span key={c.label} className="rounded-lg border border-slate-200 bg-white/80 px-2 py-1 text-xs dark:border-slate-700 dark:bg-slate-800">
              <span className="text-slate-500">{c.label}: </span>
              <span className="font-medium text-slate-800 dark:text-slate-200">{c.value}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
